import { jsx as i } from "react/jsx-runtime";
import { FAIcon as t } from "./FAIcon/FAIcon.mjs";
import { faArrowDown as n } from "@fortawesome/pro-solid-svg-icons/faArrowDown";
import { faArrowDownArrowUp as l } from "@fortawesome/pro-solid-svg-icons/faArrowDownArrowUp";
import { faArrowLeft as f } from "@fortawesome/pro-solid-svg-icons/faArrowLeft";
import { faArrowLeftLongToLine as m } from "@fortawesome/pro-solid-svg-icons/faArrowLeftLongToLine";
import { faArrowRight as e } from "@fortawesome/pro-solid-svg-icons/faArrowRight";
import { faArrowRightFromBracket as c } from "@fortawesome/pro-solid-svg-icons/faArrowRightFromBracket";
import { faArrowRightLongToLine as s } from "@fortawesome/pro-solid-svg-icons/faArrowRightLongToLine";
import { faArrowUp as p } from "@fortawesome/pro-solid-svg-icons/faArrowUp";
import { faArrowUpFromBracket as d } from "@fortawesome/pro-solid-svg-icons/faArrowUpFromBracket";
import { faArrowUpRightFromSquare as h } from "@fortawesome/pro-solid-svg-icons/faArrowUpRightFromSquare";
import { faAtom as g } from "@fortawesome/pro-solid-svg-icons/faAtom";
import { faBars as C } from "@fortawesome/pro-solid-svg-icons/faBars";
import { faBell as w } from "@fortawesome/pro-solid-svg-icons/faBell";
import { faCalendar as $ } from "@fortawesome/pro-solid-svg-icons/faCalendar";
import { faCartShopping as u } from "@fortawesome/pro-solid-svg-icons/faCartShopping";
import { faCheck as A } from "@fortawesome/pro-solid-svg-icons/faCheck";
import { faChevronDown as I } from "@fortawesome/pro-solid-svg-icons/faChevronDown";
import { faChevronLeft as k } from "@fortawesome/pro-solid-svg-icons/faChevronLeft";
import { faChevronRight as U } from "@fortawesome/pro-solid-svg-icons/faChevronRight";
import { faChevronUp as D } from "@fortawesome/pro-solid-svg-icons/faChevronUp";
import { faCircle as L } from "@fortawesome/pro-solid-svg-icons/faCircle";
import { faCircleCheck as S } from "@fortawesome/pro-solid-svg-icons/faCircleCheck";
import { faCircleDot as F } from "@fortawesome/pro-solid-svg-icons/faCircleDot";
import { faCircleExclamation as v } from "@fortawesome/pro-solid-svg-icons/faCircleExclamation";
import { faCircleInfo as R } from "@fortawesome/pro-solid-svg-icons/faCircleInfo";
import { faCircleQuestion as y } from "@fortawesome/pro-solid-svg-icons/faCircleQuestion";
import { faCircleXmark as B } from "@fortawesome/pro-solid-svg-icons/faCircleXmark";
import { faCloudArrowUp as E } from "@fortawesome/pro-solid-svg-icons/faCloudArrowUp";
import { faComment as x } from "@fortawesome/pro-solid-svg-icons/faComment";
import { faCreditCard as T } from "@fortawesome/pro-solid-svg-icons/faCreditCard";
import { faCreditCardFront as X } from "@fortawesome/pro-solid-svg-icons/faCreditCardFront";
import { faDollarSign as G } from "@fortawesome/pro-solid-svg-icons/faDollarSign";
import { faEye as b } from "@fortawesome/pro-solid-svg-icons/faEye";
import { faEyeSlash as M } from "@fortawesome/pro-solid-svg-icons/faEyeSlash";
import { faFilter as q } from "@fortawesome/pro-solid-svg-icons/faFilter";
import { faGripDotsVertical as Q } from "@fortawesome/pro-solid-svg-icons/faGripDotsVertical";
import { faMagnifyingGlass as V } from "@fortawesome/pro-solid-svg-icons/faMagnifyingGlass";
import { faMinus as P } from "@fortawesome/pro-solid-svg-icons/faMinus";
import { faPlus as Y } from "@fortawesome/pro-solid-svg-icons/faPlus";
import { faSolarSystem as j } from "@fortawesome/pro-solid-svg-icons/faSolarSystem";
import { faTriangleExclamation as z } from "@fortawesome/pro-solid-svg-icons/faTriangleExclamation";
import { faXmark as H } from "@fortawesome/pro-solid-svg-icons/faXmark";
import { faArrowDown as J } from "@fortawesome/pro-light-svg-icons/faArrowDown";
import { faArrowDownArrowUp as K } from "@fortawesome/pro-light-svg-icons/faArrowDownArrowUp";
import { faArrowLeft as N } from "@fortawesome/pro-light-svg-icons/faArrowLeft";
import { faArrowLeftLongToLine as O } from "@fortawesome/pro-light-svg-icons/faArrowLeftLongToLine";
import { faArrowRight as W } from "@fortawesome/pro-light-svg-icons/faArrowRight";
import { faArrowRightFromBracket as Z } from "@fortawesome/pro-light-svg-icons/faArrowRightFromBracket";
import { faArrowRightLongToLine as _ } from "@fortawesome/pro-light-svg-icons/faArrowRightLongToLine";
import { faArrowUp as oo } from "@fortawesome/pro-light-svg-icons/faArrowUp";
import { faArrowUpFromBracket as ro } from "@fortawesome/pro-light-svg-icons/faArrowUpFromBracket";
import { faArrowUpRightFromSquare as io } from "@fortawesome/pro-light-svg-icons/faArrowUpRightFromSquare";
import { faAtom as to } from "@fortawesome/pro-light-svg-icons/faAtom";
import { faBars as ao } from "@fortawesome/pro-light-svg-icons/faBars";
import { faBell as no } from "@fortawesome/pro-light-svg-icons/faBell";
import { faCalendar as lo } from "@fortawesome/pro-light-svg-icons/faCalendar";
import { faCartShopping as fo } from "@fortawesome/pro-light-svg-icons/faCartShopping";
import { faCheck as mo } from "@fortawesome/pro-light-svg-icons/faCheck";
import { faChevronDown as eo } from "@fortawesome/pro-light-svg-icons/faChevronDown";
import { faChevronLeft as co } from "@fortawesome/pro-light-svg-icons/faChevronLeft";
import { faChevronRight as so } from "@fortawesome/pro-light-svg-icons/faChevronRight";
import { faChevronUp as po } from "@fortawesome/pro-light-svg-icons/faChevronUp";
import { faCircle as ho } from "@fortawesome/pro-light-svg-icons/faCircle";
import { faCircleCheck as go } from "@fortawesome/pro-light-svg-icons/faCircleCheck";
import { faCircleDot as Co } from "@fortawesome/pro-light-svg-icons/faCircleDot";
import { faCircleExclamation as wo } from "@fortawesome/pro-light-svg-icons/faCircleExclamation";
import { faCircleInfo as $o } from "@fortawesome/pro-light-svg-icons/faCircleInfo";
import { faCircleQuestion as uo } from "@fortawesome/pro-light-svg-icons/faCircleQuestion";
import { faCircleXmark as Ao } from "@fortawesome/pro-light-svg-icons/faCircleXmark";
import { faCloudArrowUp as Io } from "@fortawesome/pro-light-svg-icons/faCloudArrowUp";
import { faComment as ko } from "@fortawesome/pro-light-svg-icons/faComment";
import { faCreditCard as Uo } from "@fortawesome/pro-light-svg-icons/faCreditCard";
import { faCreditCardFront as Do } from "@fortawesome/pro-light-svg-icons/faCreditCardFront";
import { faDollarSign as Lo } from "@fortawesome/pro-light-svg-icons/faDollarSign";
import { faEye as So } from "@fortawesome/pro-light-svg-icons/faEye";
import { faEyeSlash as Fo } from "@fortawesome/pro-light-svg-icons/faEyeSlash";
import { faFilter as vo } from "@fortawesome/pro-light-svg-icons/faFilter";
import { faGripDotsVertical as Ro } from "@fortawesome/pro-light-svg-icons/faGripDotsVertical";
import { faMagnifyingGlass as yo } from "@fortawesome/pro-light-svg-icons/faMagnifyingGlass";
import { faMinus as Bo } from "@fortawesome/pro-light-svg-icons/faMinus";
import { faPlus as Eo } from "@fortawesome/pro-light-svg-icons/faPlus";
import { faSolarSystem as xo } from "@fortawesome/pro-light-svg-icons/faSolarSystem";
import { faTriangleExclamation as To } from "@fortawesome/pro-light-svg-icons/faTriangleExclamation";
import { faXmark as Xo } from "@fortawesome/pro-light-svg-icons/faXmark";
import { faFacebook as Go } from "@fortawesome/free-brands-svg-icons/faFacebook";
import { faInstagram as bo } from "@fortawesome/free-brands-svg-icons/faInstagram";
import { faYoutube as Mo } from "@fortawesome/free-brands-svg-icons/faYoutube";
import { faXTwitter as qo } from "@fortawesome/free-brands-svg-icons/faXTwitter";
import { faLinkedin as Qo } from "@fortawesome/free-brands-svg-icons/faLinkedin";
const a = {
  arrowDown: { solid: n, light: J },
  arrowDownArrowUp: { solid: l, light: K },
  arrowLeft: { solid: f, light: N },
  arrowLeftLongToLine: { solid: m, light: O },
  arrowRight: { solid: e, light: W },
  arrowRightFromBracket: { solid: c, light: Z },
  arrowRightLongToLine: { solid: s, light: _ },
  arrowUp: { solid: p, light: oo },
  arrowUpFromBracket: { solid: d, light: ro },
  arrowUpRightFromSquare: {
    solid: h,
    light: io
  },
  atom: { solid: g, light: to },
  bars: { solid: C, light: ao },
  bell: { solid: w, light: no },
  calendar: { solid: $, light: lo },
  cartShopping: { solid: u, light: fo },
  check: { solid: A, light: mo },
  chevronDown: { solid: I, light: eo },
  chevronLeft: { solid: k, light: co },
  chevronRight: { solid: U, light: so },
  chevronUp: { solid: D, light: po },
  circle: { solid: L, light: ho },
  circleCheck: { solid: S, light: go },
  circleDot: { solid: F, light: Co },
  circleExclamation: { solid: v, light: wo },
  circleInfo: { solid: R, light: $o },
  circleQuestion: { solid: y, light: uo },
  circleXmark: { solid: B, light: Ao },
  cloudArrowUp: { solid: E, light: Io },
  comment: { solid: x, light: ko },
  creditCard: { solid: T, light: Uo },
  creditCardFront: { solid: X, light: Do },
  dollarSign: { solid: G, light: Lo },
  eye: { solid: b, light: So },
  eyeSlash: { solid: M, light: Fo },
  filter: { solid: q, light: vo },
  gripDotsVertical: { solid: Q, light: Ro },
  magnifyingGlass: { solid: V, light: yo },
  minus: { solid: P, light: Bo },
  plus: { solid: Y, light: Eo },
  solarSystem: { solid: j, light: xo },
  triangleExclamation: { solid: z, light: To },
  xmark: { solid: H, light: Xo }
}, Di = ({ variant: r = "solid", ...o }) => /* @__PURE__ */ i(t, { icon: a.arrowDown[`${r}`], ...o }), Li = ({ variant: r = "solid", ...o }) => /* @__PURE__ */ i(t, { icon: a.arrowDownArrowUp[`${r}`], ...o }), Si = ({ variant: r = "solid", ...o }) => /* @__PURE__ */ i(t, { icon: a.arrowLeft[`${r}`], ...o }), Fi = ({ variant: r = "solid", ...o }) => /* @__PURE__ */ i(t, { icon: a.arrowRightFromBracket[`${r}`], ...o }), vi = ({ variant: r = "solid", ...o }) => /* @__PURE__ */ i(t, { icon: a.arrowUp[`${r}`], ...o }), Ri = ({ variant: r = "solid", ...o }) => /* @__PURE__ */ i(t, { icon: a.arrowUpFromBracket[`${r}`], ...o }), yi = ({ variant: r = "solid", ...o }) => /* @__PURE__ */ i(t, { icon: a.arrowUpRightFromSquare[`${r}`], ...o }), Bi = ({ variant: r = "solid", ...o }) => /* @__PURE__ */ i(t, { icon: a.bars[`${r}`], ...o }), Ei = ({ variant: r = "solid", ...o }) => /* @__PURE__ */ i(t, { icon: a.bell[`${r}`], ...o }), xi = ({ variant: r = "solid", ...o }) => /* @__PURE__ */ i(t, { icon: a.calendar[`${r}`], ...o }), Ti = ({ variant: r = "solid", ...o }) => /* @__PURE__ */ i(t, { icon: a.cartShopping[`${r}`], ...o }), Xi = ({ variant: r = "solid", ...o }) => /* @__PURE__ */ i(t, { icon: a.chevronDown[`${r}`], ...o }), Gi = ({ variant: r = "solid", ...o }) => /* @__PURE__ */ i(t, { icon: a.chevronLeft[`${r}`], ...o }), bi = ({ variant: r = "solid", ...o }) => /* @__PURE__ */ i(t, { icon: a.chevronRight[`${r}`], ...o }), Mi = ({ variant: r = "solid", ...o }) => /* @__PURE__ */ i(t, { icon: a.chevronUp[`${r}`], ...o }), qi = ({ variant: r = "solid", ...o }) => /* @__PURE__ */ i(t, { icon: a.circle[`${r}`], ...o }), Qi = ({ variant: r = "solid", ...o }) => /* @__PURE__ */ i(t, { icon: a.circleCheck[`${r}`], ...o }), Vi = ({ variant: r = "solid", ...o }) => /* @__PURE__ */ i(t, { icon: a.circleDot[`${r}`], ...o }), Pi = ({ variant: r = "solid", ...o }) => /* @__PURE__ */ i(t, { icon: a.circleExclamation[`${r}`], ...o }), Yi = ({ variant: r = "solid", ...o }) => /* @__PURE__ */ i(t, { icon: a.circleInfo[`${r}`], ...o }), ji = ({ variant: r = "solid", ...o }) => /* @__PURE__ */ i(t, { icon: a.circleQuestion[`${r}`], ...o }), zi = ({ variant: r = "solid", ...o }) => /* @__PURE__ */ i(t, { icon: a.circleXmark[`${r}`], ...o }), Hi = ({ variant: r = "solid", ...o }) => /* @__PURE__ */ i(t, { icon: a.cloudArrowUp[`${r}`], ...o }), Ji = ({ variant: r = "solid", ...o }) => /* @__PURE__ */ i(t, { icon: a.comment[`${r}`], ...o }), Ki = ({ variant: r = "solid", ...o }) => /* @__PURE__ */ i(t, { icon: a.creditCard[`${r}`], ...o }), Ni = ({ variant: r = "solid", ...o }) => /* @__PURE__ */ i(t, { icon: a.creditCardFront[`${r}`], ...o }), Oi = ({ variant: r = "solid", ...o }) => /* @__PURE__ */ i(t, { icon: a.dollarSign[`${r}`], ...o }), Wi = ({ variant: r = "solid", ...o }) => /* @__PURE__ */ i(t, { icon: a.eye[`${r}`], ...o }), Zi = ({ variant: r = "solid", ...o }) => /* @__PURE__ */ i(t, { icon: a.eyeSlash[`${r}`], ...o }), _i = ({ variant: r = "solid", ...o }) => /* @__PURE__ */ i(t, { icon: Go, ...o }), ot = ({ variant: r = "solid", ...o }) => /* @__PURE__ */ i(t, { icon: a.filter[`${r}`], ...o }), rt = ({ variant: r = "solid", ...o }) => /* @__PURE__ */ i(t, { icon: a.gripDotsVertical[`${r}`], ...o }), it = ({ variant: r = "solid", ...o }) => /* @__PURE__ */ i(t, { icon: bo, ...o }), tt = ({ variant: r = "solid", ...o }) => /* @__PURE__ */ i(t, { icon: Qo, ...o }), at = ({ variant: r = "solid", ...o }) => /* @__PURE__ */ i(t, { icon: a.magnifyingGlass[`${r}`], ...o }), nt = ({ variant: r = "solid", ...o }) => /* @__PURE__ */ i(t, { icon: a.solarSystem[`${r}`], ...o }), lt = ({ variant: r = "solid", ...o }) => /* @__PURE__ */ i(t, { icon: a.triangleExclamation[`${r}`], ...o }), ft = ({ variant: r = "solid", ...o }) => /* @__PURE__ */ i(t, { icon: a.xmark[`${r}`], ...o }), mt = ({ variant: r = "solid", ...o }) => /* @__PURE__ */ i(t, { icon: qo, ...o }), et = ({ variant: r = "solid", ...o }) => /* @__PURE__ */ i(t, { icon: Mo, ...o });
export {
  Li as ArrowDownArrowUpIcon,
  Di as ArrowDownIcon,
  Si as ArrowLeftIcon,
  Fi as ArrowRightFromBracketIcon,
  Ri as ArrowUpFromBracketIcon,
  vi as ArrowUpIcon,
  yi as ArrowUpRightFromSquare,
  Bi as BarsIcon,
  Ei as BellIcon,
  xi as CalendarIcon,
  Ti as CartShoppingIcon,
  Xi as ChevronDownIcon,
  Gi as ChevronLeftIcon,
  bi as ChevronRightIcon,
  Mi as ChevronUpIcon,
  Qi as CircleCheckIcon,
  Vi as CircleDotIcon,
  Pi as CircleExclamationIcon,
  qi as CircleIcon,
  Yi as CircleInfoIcon,
  ji as CircleQuestionIcon,
  zi as CircleXMarkIcon,
  Hi as CloudArrorUpIcon,
  Ji as CommentIcon,
  Ni as CreditCardFrontIcon,
  Ki as CreditCardIcon,
  Oi as DollarSignIcon,
  Wi as EyeIcon,
  Zi as EyeSlashIcon,
  _i as FacebookIcon,
  ot as FilterIcon,
  rt as GripDotsVerticalIcon,
  it as InstagramIcon,
  tt as LinkedInIcon,
  at as MagnifyingGlassIcon,
  nt as SolarSystemIcon,
  lt as TriangleExclamationIcon,
  mt as XTwitterIcon,
  ft as XmarkIcon,
  et as YouTubeIcon
};
